import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { IGetState } from '../../../../../../../types/types';
import { IQuestion } from '../../../../../base/components/Poll/components/Poll/types';
import { POLL_DELAY_AFTER } from '../../../../../base/components/Poll/components/constants';
import { segmentTrackAction, SegmentUserEvent } from '../../../../../../../middlewares/segment';
import { SegmentUserOption } from '../../../../../../../middlewares/segment/trackEntities/userEvents';
import { authUserSetRateKanbanPoll } from '../../../../../../../rest/effects/authUser/authUserSetRateKanbanPoll';
import { authUserEmailSelector } from '../../../../../dialogs/feedback/store/selectors/authUserEmailSelector';
import {
    EFeedbackCategory,
    HP_DEFAULT_PRIORITY,
    HP_DEFAULT_STATUS,
    HP_ERROR_EMAIL,
    HP_ERROR_FULL_NAME
} from '../../../../../dialogs/feedback';
import { getTicketTags } from '../../../../../dialogs/feedback/helpers/getTicketTags';
import { authUserFullNameSelector } from '../../../../../dialogs/feedback/store/selectors/authUserFullNameSelector';
import { IHelpPopupTicket } from '../../../../../dialogs/feedback/types';
import { ticketSender } from '../../../../../dialogs/feedback/helpers/ticketSender';
import { getFeedbackSession } from '../../../../../dialogs/feedback/helpers/fileService';

export const onSubmit = (
    results: IQuestion[],
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(segmentTrackAction(SegmentUserEvent.RATE_KANBAN_POLL_RATED, {
            name: SegmentUserOption.RATING,
            value: results[0].answer as number + 1
        }));
        if (results[1]?.answer) {
            const state = getState();
            const email = authUserEmailSelector(state) || HP_ERROR_EMAIL;
            const ticketTags = getTicketTags(state, EFeedbackCategory.DEFAULT);
            const fullName = authUserFullNameSelector(state) || HP_ERROR_FULL_NAME;
            const ticket: IHelpPopupTicket = {
                email,
                fullName,
                subject: 'Rate kanban poll [app]',
                description: `[${results[0].answer as number + 1} stars] ${results[1].answer}`,
                tags: ticketTags,
                priority: HP_DEFAULT_PRIORITY,
                status: HP_DEFAULT_STATUS,
            };
            getFeedbackSession().then(sessionId => {
                ticketSender(ticket, sessionId);
            });
        }
        setTimeout(() => {
            dispatch(authUserSetRateKanbanPoll({ isShowed: true }));
        }, POLL_DELAY_AFTER) // только что ответил, показать Thank you
    };
    return action;
};
